import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Button from 'shared/app/components/button-with-messages';
import EmailField from 'shared/app/components/email-field';
import { queryParamsSelector } from 'shared/app/state/selectors/routes';
import { sharedCallsToAction } from 'shared/app/messages';
import messages from './messages';

const PersonalInformationForm = ({ fields, loading }) => {
  const { formatMessage } = useIntl();
  const queryParams = useSelector(queryParamsSelector);
  const isNativeView = Boolean(queryParams?.platform);
  const { emailAddress } = fields;
  // TrustArc method to open cookie preferences dialog
  const handleClick = () => truste?.eu?.clickListener?.(1);
  return (
    <React.Fragment>
      <div className="py3">
        <EmailField className="pb3" field={emailAddress} hasHint={false} />
      </div>
      <div className="flex flex-column items-center">
        <Button loading={loading} type="submit" visualStyle="positive">
          {formatMessage(sharedCallsToAction.submit)}
        </Button>

        {!isNativeView && (
          <Button className="mt3 py2" onClick={handleClick}>
            {formatMessage(messages.manageCookiePreferences)}
          </Button>
        )}
      </div>
    </React.Fragment>
  );
};

PersonalInformationForm.propTypes = {
  fields: PropTypes.object,
};

export default PersonalInformationForm;
